module.exports = __webpack_public_path__ + "static/media/customDesignStep2Mobile.5414452d.PNG";